var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0973 11.2453V9.2327M12.0973 11.2453C12.0973 11.3564 12.0102 11.4465 11.9027 11.4465H6.45133C6.3438 11.4465 6.25664 11.3564 6.25664 11.2453V9.2327C6.25664 8.34349 6.95396 7.62264 7.81416 7.62264H10.5398C11.4 7.62264 12.0973 8.34349 12.0973 9.2327M12.0973 11.2453C12.0973 11.3564 12.1845 11.4465 12.292 11.4465H17.7434C17.8509 11.4465 17.9381 11.3564 17.9381 11.2453V9.2327C17.9381 8.34349 17.2407 7.62264 16.3805 7.62264H13.6549C12.7947 7.62264 12.0973 8.34349 12.0973 9.2327M3.14159 17.8868V20M20.8584 17.8868V20M1.19469 17.8868H22.8053C22.9128 17.8868 23 17.7967 23 17.6855V13.6604C23 12.4377 22.0412 11.4465 20.8584 11.4465H3.14159C1.95882 11.4465 1 12.4377 1 13.6604V17.6855C1 17.7967 1.08717 17.8868 1.19469 17.8868ZM3.33628 11.4465H20.6637C20.7712 11.4465 20.8584 11.3564 20.8584 11.2453V5.61006C20.8584 4.72085 20.1611 4 19.3009 4H4.69911C3.83892 4 3.14159 4.72085 3.14159 5.61006V11.2453C3.14159 11.3564 3.22876 11.4465 3.33628 11.4465Z",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/Bed.a59d838a404dabe8dd0c86d282c417ac.svg";
export { ForwardRef as ReactComponent };